var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmshisotry5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 303,
    height: 303,
    viewBox: "0 0 303 303",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.5 0C235.173 0 303 67.8266 303 151.5C303 235.173 235.173 303 151.5 303C125.715 303 101.429 296.561 80.1738 285.199L0 303L17.8164 222.856C6.4539 201.586 0 177.3 0 151.5C0 67.8266 67.8266 0 151.5 0ZM151.5 30.3C84.5673 30.3 30.3 84.5673 30.3 151.5C30.3 171.725 35.2389 191.163 44.541 208.555L49.8435 218.463L39.9051 263.095L84.5673 253.187L94.4602 258.474C111.852 267.776 131.275 272.7 151.5 272.7C218.433 272.7 272.7 218.433 272.7 151.5C272.7 84.5673 218.433 30.3 151.5 30.3ZM166.65 75.75V151.5H227.25V181.8H136.35V75.75H166.65Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmshisotry5);
export default __webpack_public_path__ + "static/media/sms hisotry (5).090dbc05691bec2f19f777690691e085.svg";
export { ForwardRef as ReactComponent };